import { ArrowUpRight, Quote } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { BUSINESS } from "@/lib/site";

const REVIEWS = [
  { name: "Eric B.", text: "District Gaslight is a 10/10!!! I am a frequent flyer and love the product and the service! Shoutout to Amal who is super helpful and knowledgeable! Definitely stop by as it's worth the visit!" },
  { name: "Cailes G.", text: "This place is so good! Very accessible and so accommodating. Good prices. 10/10" },
  { name: "Victor", text: "Great professional staff ... always willing to help you find the best strain to suit your daily needs. I've been coming here for 9 months and highly recommend this dispensary to all." },
  { name: "Ahmed I.", text: "I've been a loyal customer for a very long time. Very hospitable, respectful, and helpful people here." },
  { name: "Bruno F.", text: "This little shop has everything you need to relax with great quality and good price. The guys behind the counters are great too." },
  { name: "Helena B.", text: "This place was so chill and lovely! The owner was so knowledgeable and helped me to make the right decision!" },
];

const ReviewCard = ({ name, text, i }) => (
  <Reveal delay={0.05 * (i % 3)} className="h-full">
    <figure className="flex h-full flex-col justify-between rounded-2xl border border-brand-ink/10 bg-white p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]" data-testid={`review-card-${i + 1}`}>
      <div>
        <Quote className="h-7 w-7 text-brand-red" aria-hidden="true" />
        <blockquote className="mt-4 text-sm leading-relaxed text-neutral-700 sm:text-base">{text}</blockquote>
      </div>
      <figcaption className="mt-6 flex items-center justify-between border-t border-neutral-200 pt-4 text-sm">
        <span className="font-bold text-brand-ink">{name}</span>
        <span className="text-xs font-semibold uppercase tracking-wider text-neutral-500">Google review</span>
      </figcaption>
    </figure>
  </Reveal>
);

export const Reviews = () => (
  <section className="bg-brand-sand py-20 sm:py-28" data-testid="home-reviews">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <Reveal className="mb-10 flex flex-wrap items-end justify-between gap-6">
        <SectionHead eyebrow="From our customers" title="What People Say">
          <p className="mt-3 max-w-md text-sm text-neutral-600">Real reviews left by District Gaslight customers on Google.</p>
        </SectionHead>
        <a href={BUSINESS.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn-dark inline-flex items-center gap-1.5" data-testid="reviews-read-all-link">
          Read all reviews <ArrowUpRight className="h-4 w-4" />
        </a>
      </Reveal>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {REVIEWS.map((r, i) => <ReviewCard key={r.name} {...r} i={i} />)}
      </div>
    </div>
  </section>
);
